<template>
    <v-container fluid>
        <v-card>
            <v-tabs v-model="tab" align-with-title background-color="primary" dark>
                <v-tab v-for="item in items" :key="item">
                    {{ $t(`${item}.plural`) }}
                </v-tab>
            </v-tabs>
        </v-card>

        <v-card>
            <v-tabs-items v-model="tab">

                <!--Sales-->
                <v-tab-item :key="items[0]">
                    <DateRangePicker @criteria-changed="salesCriteriaChanged">
                        <template slot="content">

                            <v-toolbar-title class="field_color">{{$t('general.price_sum')}} : {{price_sum}} ‎€
                            </v-toolbar-title>
                            <v-toolbar-title class="field_color mb-5">{{$t('general.remaining_balance_sum')}}
                                : {{remaining_balance_sum}} ‎€
                            </v-toolbar-title>

                            <SalesList :criteria="salesCriteria" @data-changed="salesDataChanged"></SalesList>
                        </template>
                    </DateRangePicker>
                </v-tab-item>

                <!--Expenses-->
                <v-tab-item :key="items[1]">
                    <v-card flat>
                        <DateRangePicker @criteria-changed="expensesCriteriaChanged">
                            <template slot="content">

                                <v-toolbar-title class="field_color mb-5">{{$t('general.amount_sum')}} : {{amount_sum}} €
                                </v-toolbar-title>

                                <ExpensesList :criteria="expensesCriteria" @data-changed="expensesDataChanged">
                                </ExpensesList>
                            </template>
                        </DateRangePicker>
                    </v-card>
                </v-tab-item>
            </v-tabs-items>
        </v-card>
    </v-container>
</template>

<script type="text/babel">
    import DateRangePicker from '../components/DateRangePicker.vue'
    import SalesList from '../components/SalesList.vue'
    import ExpensesList from '../components/ExpensesList.vue'

    export default {
        components: {
            DateRangePicker, SalesList, ExpensesList
        },
        data: self => ({
            tab: null,
            items: [
                'sales', 'expenses'
            ],
            salesCriteria: null,
            expensesCriteria: null,

            price_sum: 0,
            remaining_balance_sum: 0,
            amount_sum: 0,
        }),
        methods: {
            // change on criteria from date range component for sales list
            salesCriteriaChanged(criteria) {
                this.salesCriteria = criteria;
            },
            // change on criteria from date range component for expenses list
            expensesCriteriaChanged(criteria) {
                this.expensesCriteria = criteria;
            },
            // change on sales data
            salesDataChanged(data) {
                this.price_sum = data.price_sum;
                this.remaining_balance_sum = data.remaining_balance_sum;
            },
            // change on expenses data
            expensesDataChanged(data) {
                this.amount_sum = data.amount_sum;
            }
        }
    }
</script>
